import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { WizardComponent } from './wizard/wizard.component';

const routes: Routes = [
  {
    path: 'wizard',
    component: WizardComponent,
    data: { title: 'Instructivo de Embarque' },
  },
  { path: '', redirectTo: 'wizard', pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class InstructivoEmbarqueRoutingModule {}
